import {connect} from "react-redux";
import PaymentUcdCaseInvoice from "./paymentInvoice";
import {bindActionCreators} from "redux";
import {
    getVendorRequestSubmit,
    getPaymentRequestDetails,
    getVendorPo,
    saveVendorPayment
} from "services/redux/sales/vendorPortal/action";
import {documentUploadUrl} from "services/redux/fileUpload/action";
import {caseByLsqDealerIdRequest} from "../../../../../services/redux/CarLoan/action";


import {
    fetchZones,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
    getVendorDetails: state.vendorPortalReducer.vendorPaymentAdd,
    poDetail: state.vendorPortalReducer.poDetail,
    caseByLsqDealerIdResponse : state.CarLoan.caseByLsqDealerIdResponse,

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchZones,
            getVendorRequestSubmit,
            getPaymentRequestDetails,
            getVendorPo,
            saveVendorPayment,
            documentUploadUrl,
            caseByLsqDealerIdRequest,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentUcdCaseInvoice);
